import {normalizeUrl} from '../utils/normalizeUrl';

export const CARVAGO_URL = normalizeUrl(process.env.CARVAGO_URL ?? '');
